import { ChainId } from '@pancakeswap/chains'
import { atom } from 'jotai'
import { useDeferredValue } from 'react'
import { useNetwork } from 'wagmi'

const queryChainIdAtom = atom(-1) // -1 unload, 0 no chainId on query

queryChainIdAtom.onMount = (set) => {
  set(0)
}

export function useLocalNetworkChain() {
  return ChainId.BSC
}

export const useActiveChainId = () => {
  const localChainId = useLocalNetworkChain()

  const { chain } = useNetwork()
  const chainId = localChainId ?? chain?.id
  const isNotMatched = useDeferredValue(chain && localChainId && chain.id !== localChainId)

  return {
    chainId,
    isWrongNetwork: (chain?.unsupported ?? false) || isNotMatched,
    isNotMatched,
  }
}
